import { createSelector } from 'reselect';
// Employment and Occupation selectors
export const employmentStatusListSelector = (state) =>
  state.employmentStatusList;
export const occupationCategoriesSelector = (state) =>
  state.employmentStatusList;
export const employmentInfoSelector = (state) => state.employmentStatusList;

export const selectEmploymentStatusList = createSelector(
  employmentStatusListSelector,
  (state) => state.EmploymentStatusList,
);

export const selectOccupationCategories = createSelector(
  occupationCategoriesSelector,
  (state) => state.OccupationCategories,
);

export const selectEmploymentInfo = createSelector(
  employmentInfoSelector,
  (state) => state.EmploymentInfo,
);

// Income Source List
export const selectIncomeSourceList = createSelector(
  employmentStatusListSelector,
  (state) => state.IncomeSourceList,
);
